import { environment } from '../environments/environment';

//import { environment } from "../environments/environment.prod";

// Use environment configuration
export const GlobalVariable = Object.freeze({
  LOGIN_URL: environment.loginUrl,
  BASE_URL: environment.baseUrl,
  SSOCLIENTID: environment.ssoClientId,
  SSOAUTHURL: environment.ssoAuthUrl,
  SSOREDIRECTURL: environment.ssoRedirectUrl,
  SSOAPIURL: environment.ssoApiUrl,
    SSOAPIID: environment.ssoApiId,

    SUBKEY : 'Ocp-Apim-Subscription-Key',
    SUBKEY_VALUE: environment.apiGatewaySubscriptionKey,
    
});

// Export BASE_URL separately for easier importing
export const BASE_URL = GlobalVariable.BASE_URL;

/**
 * リクエストURLに基づいて適切なベースURLを返す
 * API Gateway未登録のadminパスは直接接続URLを返す
 */
export function getBaseUrlForRequest(requestPath: string): string {
  // API Gatewayを使用しない場合は常にapiUrlを使用
  if (!environment.useApiGateway) {
    return environment.apiUrl;
  }

  // 未登録のadminパスかチェック
  const isUnregisteredPath = environment.unregisteredAdminPaths?.some(
    path => requestPath.toLowerCase().includes(path.toLowerCase())
  );

  if (isUnregisteredPath) {
    return environment.directApiUrl || environment.apiUrl;
  }

  // 登録済みパスはAPI Gateway経由（通常のapiUrlを使用）
  return environment.apiUrl;
}
